<template>
    <!-- Mostrano i servizi del portale come card con foto e titolo che puntano alla view relativa. -->
    <div>
        <!-- Se viene definita la proprietà direct_link allora il componente si comporta come un semplice link -->
        <!-- ipertestuale aprendo la pagina lincata in un nuovo tab.                                           -->
        <b-link v-if="direct_link" :href="direct_link" :target="'_blank'" :style="setDisplayProp()">
            <b-card
                no-body
                :img-src="image"
                img-alt="Image"
                img-top
                style="max-width: 30em;"
                class="mb-2"
                footer-tag="footer"
            >
            <template v-slot:footer>
                <!-- Div per personalizzare colore e colore del testo del footer -->
                <div :style="customer_styles.voci_menu">
                    {{title}}
                </div>
            </template>
            </b-card>
        </b-link>

        <!-- Se invece la proprietà direct_link NON è definita allora il componente si comporta come -->
        <!-- link verso una route dell'interfaccia o verso un sottomenù                              -->
        <b-link v-else :to="route_name_object" @click.prevent="onClick" :style="setDisplayProp()">
            <b-card
                no-body
                :img-src="image"
                img-alt="Image"
                img-top
                style="max-width: 30em;"
                class="mb-2"
                footer-tag="footer"
            >
            <template v-slot:footer>
                <!-- Div per personalizzare colore e colore del testo del footer -->
                <div :style="customer_styles.voci_menu">
                    {{title}}
                </div>
            </template>
            </b-card>
        </b-link>
    </div>
</template>

<script>
import { customerStylesMixin } from '@/mixins/customerStylesMixin'

export default {
    name: 'ServiceBadge',
    mixins: [ customerStylesMixin ],
    data () {
        return {}
    },
    methods: {
        /**
         * Se la proprietà show_badge è false setta la proprietà
         * display del link a none nascondendo la card.
         */
        setDisplayProp : function () {
            if ( this.show_badge ) {
                return "display : block";
            } else {
                return "display : none";
            }
        },
        /**
         * Al click se il badge punta verso una route non accade nulla,
         * dobbiamo seguire la Route.
         * Se invece punta ad una sottosezione allora viene
         * emesso l'evento che segnala al menù principale di aprire questa
         * sottosezione.
         */
        onClick : function () {
            if ( this.route_name === '' && this.subsection_name === null ) {
                return;
            } else {
                this.$emit( 'openSubsection', { subsection_name : this.subsection_name } );
            }
        }
    },
    computed : {
        /**
         * Trasforma il nome della route nell'oggetto adatto
         * per il router.
         */
        route_name_object : function ( value ) {
            return { 'name' : this.route_name }
        }
    },
    props: {
        /**
         * Il titolo del badge
         */
        title: {
            type: String,
            default: ''
        },
        /**
         * Immagine da visualizzare nel badge
         */
        image: {
            type: String,
            default: null
        },
        /**
         * Nome della route a cui il badge si riferisce se è
         * un badge che linka direttamente un pagina
         */
        route_name: {
            type: String,
            default : ''
        },
        /**
         * Se il badge si riferisce ad una sottosezione allora qui
         * viene passato il nome della sottosezione.
         */
        subsection_name: {
            type: String,
            default: null
        },
        /**
         * Nasconde il badge
         */
        show_badge: {
            type: Boolean,
            default: true
        },
        /**
         * Se definito il badge non apre una route del router vue ma un
         * link http in un nuovo tab.
         */
        direct_link: {
            type: String,
            default: null
        }
    }
}
</script>

<style scoped>
a:hover .card-img-top{
    filter: blur(2px);
}
a:hover {
    text-decoration: none;
}
/* Annulla il padding del footer di bootstrap di modo
   tale che tutto il footer è rappresentato dal div che vi
   è inserito dentro ed il cui style è personalizzato in base
   al customer */
.card-footer {
    padding: 0px;
}
</style>
